<div class="page-header-container">
    <div class="page-title">
        {{ "requests.clientData.newRequest.Title" | translate }}
    </div>
</div>
  
<div class="wizard-container">
    <ng-container *ngIf="!isRequestSaved">
        <button class="btn link-btn btn-back-txt" (click)="redirectFieldSelectionHandler()">
            <i class="app-icon icon icon-arrow-left icon-xl me-2"></i>
            <span>{{'requests.clientData.newRequest.Back' | translate}}</span>
        </button>
        <div class="d-flex justify-content-center fw-bold fs-4 l-preview-title">
            {{ "requests.clientData.preview.title" | translate }}
        </div>

        <div class="d-flex flex-column justify-content-start pb-3 mb-4">
            <div class="l-item-section">
                <span class="l-section-title fw-semibold">{{ "requests.clientData.preview.requestType" | translate }}</span>
                <div HJSuppress class="section-content">
                    <ul>
                        <li>{{requestType?.value}}</li>
                    </ul>
                    <button class="btn edit-btn custom-edit-btn ms-auto"
                        (click)="redirectRequestTypeHandler()">
                        <i class="app-icon icon icon-edit icon-xl"></i>
                    </button>
                </div>
            </div>
            <div class="l-item-section" *ngIf="requestType && requestType.code === clientDataRequestType.Address">
                <span class="l-section-title fw-semibold">{{ "requests.clientData.preview.address" | translate }}</span>
                <div HJSuppress class="section-content" *ngFor="let address of clientDataRequestSaveModel.addresses; let isFirst, let isLast">
                    <div class="d-flex flex-column">
                        <div *ngIf="isFirst" class="l-section-subtitle fw-semibold">
                            {{ isPJ ? ("requests.clientData.newRequest.address.TitlePJ" | translate) : 
                            ("requests.clientData.newRequest.address.TitlePF" | translate)
                            }}
                        </div>
                        <div *ngIf="isLast" class="l-section-subtitle fw-semibold">
                            {{ "requests.clientData.preview.mailingAddress" | translate}}
                        </div>
                        <ul>
                            <li>
                                <span>
                                    {{ "requests.clientData.newRequest.address.Country" | translate }}: 
                                    <span class="fw-semibold">{{address.country}}</span>
                                </span>
                            </li>
                            <li>
                                <span>
                                    {{ "requests.clientData.newRequest.address.State" | translate }}:
                                    <span class="fw-semibold">{{address.state}}</span>
                                </span>
                            </li>
                            <li>
                                <span>
                                    {{ "requests.clientData.newRequest.address.City" | translate }}:
                                    <span class="fw-semibold">{{address.city}}</span>
                                </span>
                            </li>
                            <li>
                                <span>
                                    {{ "requests.clientData.newRequest.address.PostalCode" | translate }}:
                                    <span class="fw-semibold">{{address.postalCode}}</span>
                                </span>
                            </li>
                            <li>
                                <span>
                                    {{"requests.clientData.newRequest.address.Street" | translate}}:
                                    <span class="fw-semibold">{{address.streetName}}</span>
                                </span>
                            </li>
                            <li>
                                <span>
                                    {{"requests.clientData.newRequest.address.StreetNo" | translate}}:
                                    <span class="fw-semibold">{{address.streetNumber}}</span>
                                </span>
                            </li>
                            <li>
                                <span>
                                    {{"requests.clientData.newRequest.address.BuildingNo" | translate}}:
                                    <span class="fw-semibold">{{address.buildingNumber}}</span>
                                </span>
                            </li>
                            <li>
                                <span>
                                    {{"requests.clientData.newRequest.address.Stair" | translate}}:
                                    <span class="fw-semibold">{{address.stair}}</span>
                                </span>
                            </li>
                            <li>
                                <span>
                                    {{"requests.clientData.newRequest.address.Floor" | translate}}:
                                    <span class="fw-semibold">{{address.floor}}</span>
                                </span>
                            </li>
                            <li>
                                <span>
                                    {{"requests.clientData.newRequest.address.Flat" | translate}}:
                                    <span class="fw-semibold">{{address.flatNumber}}</span>
                                </span>
                            </li>
                        </ul>
                    </div>   
                    <button class="btn edit-btn custom-edit-btn ms-auto"
                        (click)="redirectFieldSelectionHandler()">
                        <i class="app-icon icon icon-edit icon-xl"></i>
                    </button>
                </div>
            </div>
            <div class="l-item-section" *ngIf="requestType && requestType.code === clientDataRequestType.Associates">
                <span class="l-section-title fw-semibold">{{ "requests.clientData.preview.associates" | translate }}</span>
                <div HJSuppress class="section-content"  *ngFor="let associate of clientDataRequestSaveModel.associates">
                    <div class="d-flex flex-column">
                        <div  class="l-section-subtitle fw-semibold">
                            {{ "requests.clientData.preview.associate" | translate}}
                        </div>
                        <ul>
                            <li>
                                <span>
                                    {{'requests.clientData.newRequest.associates.Name' | translate}}: 
                                    <span class="fw-semibold">{{associate.name}}</span>
                                </span>
                            </li>
                            <li>
                                <span>
                                    {{'requests.clientData.newRequest.associates.VAT' | translate}}:
                                    <span class="fw-semibold">{{associate.vatRegistrationNumber}}</span>
                                </span>
                            </li>
                            <li>
                                <span>
                                    {{'requests.clientData.newRequest.associates.Stake' | translate}}:
                                    <span class="fw-semibold">{{associate.companyPercentage}}</span>
                                </span>
                            </li>
                    
                        </ul>
                    </div>   
                    <button class="btn edit-btn custom-edit-btn ms-auto"
                        (click)="redirectFieldSelectionHandler()">
                        <i class="app-icon icon icon-edit icon-xl"></i>
                    </button>
                </div>
            </div>
            <div class="l-item-section" *ngIf="requestType && requestType.code === clientDataRequestType.Owner">
                <span class="l-section-title fw-semibold">{{ "requests.clientData.preview.beneficialOwner" | translate }}</span>
                <div HJSuppress class="section-content">
                        <ul>
                            <li>
                                <span>
                                    {{'requests.clientData.newRequest.ownerInformation.Name' | translate}}:
                                    <span class="fw-semibold">{{clientDataRequestSaveModel.beneficialOwner.name}}</span>
                                </span>
                            </li>
                            <li>
                                <span>
                                    {{'requests.clientData.newRequest.contactInformation.Phone' | translate}}:
                                    <span class="fw-semibold">{{clientDataRequestSaveModel.beneficialOwner.phone}}</span>
                                </span>
                            </li>
                        </ul>
                    <button class="btn edit-btn custom-edit-btn ms-auto"
                        (click)="redirectFieldSelectionHandler()">
                        <i class="app-icon icon icon-edit icon-xl"></i>
                    </button>
                </div>
            </div>
            <div class="l-item-section" *ngIf="requestType && requestType.code === clientDataRequestType.CompanyInfo">
                <span class="l-section-title fw-semibold">{{ "requests.clientData.preview.companyInformation" | translate }}</span>
                <div HJSuppress class="section-content">
                        <ul>
                            <li>
                                <span>
                                    {{'requests.clientData.newRequest.infoPJ.Name' | translate}}:
                                    <span class="fw-semibold">{{clientDataRequestSaveModel.companyInformation.name}}</span>
                                </span>
                            </li>
                            <li>
                                <span>
                                    {{'requests.clientData.newRequest.infoPJ.RegistrationCode' | translate}}:
                                    <span class="fw-semibold">{{clientDataRequestSaveModel.companyInformation.registrationCode}}</span>
                                </span>
                            </li>
                            <li>
                                <span>
                                    {{'requests.clientData.newRequest.infoPJ.LegalForm' | translate}}:
                                    <span class="fw-semibold">{{clientDataRequestSaveModel.companyInformation.legalForm}}</span>
                                </span>
                            </li>
                            <li>
                                <span>
                                    {{'requests.clientData.newRequest.infoPJ.mainField' | translate}}:
                                    <span class="fw-semibold">{{clientDataRequestSaveModel.companyInformation.mainActivityField}}</span>
                                </span>
                            </li>
                        </ul>
                    <button class="btn edit-btn custom-edit-btn ms-auto"
                        (click)="redirectFieldSelectionHandler()">
                        <i class="app-icon icon icon-edit icon-xl"></i>
                    </button>
                </div>
            </div>
            <div class="l-item-section" *ngIf="requestType && requestType.code === clientDataRequestType.PersonalInfo">
                <span class="l-section-title fw-semibold">{{ "requests.clientData.preview.personalInformation" | translate }}</span>
                <div HJSuppress class="section-content">
                    <ul>
                        <li>
                            <span>
                                {{'requests.clientData.newRequest.infoPF.nameFirst' | translate}}:
                                <span class="fw-semibold">{{clientDataRequestSaveModel.personalInformation.firstName}}</span>
                            </span>
                        </li>
                        <li>
                            <span>
                                {{'requests.clientData.newRequest.infoPF.nameLast' | translate}}:
                                <span class="fw-semibold">{{clientDataRequestSaveModel.personalInformation.lastName}}</span>
                            </span>
                        </li>
                        <li>
                            <span>
                                {{'requests.clientData.newRequest.infoPF.IDseries' | translate}}:
                                <span class="fw-semibold">{{clientDataRequestSaveModel.personalInformation.idSeries}}</span>
                            </span>
                        </li>
                        <li>
                            <span>
                                {{'requests.clientData.newRequest.infoPF.IDnumber' | translate}}:
                                <span class="fw-semibold">{{clientDataRequestSaveModel.personalInformation.idNumber}}</span>
                            </span>
                        </li>
                        <li>
                            <span>
                                {{'requests.clientData.newRequest.infoPF.IssuedBy' | translate}}:
                                <span class="fw-semibold">{{clientDataRequestSaveModel.personalInformation.issuedBy}}</span>
                            </span>
                        </li>
                        <li>
                            <span>
                                {{'requests.clientData.newRequest.infoPF.ExpiryDate' | translate}}:
                                <span class="fw-semibold">{{clientDataRequestSaveModel.personalInformation.expiryDate}}</span>
                            </span>
                        </li>
                        <li>
                            <span>
                                {{'requests.clientData.newRequest.infoPF.CivilStatus' | translate}}:
                                <span class="fw-semibold">{{maritalStatus}}</span>
                            </span>
                        </li>
                    </ul>
                    <button class="btn edit-btn custom-edit-btn ms-auto"
                        (click)="redirectFieldSelectionHandler()">
                        <i class="app-icon icon icon-edit icon-xl"></i>
                    </button>
                </div>
            </div>
            <div class="l-item-section" *ngIf="requestType && requestType.code === clientDataRequestType.ContactInfo">
                <span class="l-section-title fw-semibold">{{ "requests.clientData.preview.companyInformation" | translate }}</span>
                <div HJSuppress class="section-content">
                        <ul>
                            <li>
                                <span>
                                    {{'requests.clientData.newRequest.contactInformation.Email' | translate}}:
                                    <span class="fw-semibold">{{clientDataRequestSaveModel.contactInformation.email}}</span>
                                </span>
                            </li>
                            <li>
                                <span>
                                    {{'requests.clientData.newRequest.contactInformation.Phone' | translate}}:
                                    <span class="fw-semibold">{{clientDataRequestSaveModel.contactInformation.phone}}</span>
                                </span>
                            </li>
                            <li *ngIf="isPJ">
                                <span>
                                    {{'requests.clientData.newRequest.contactInformation.Fax' | translate}}:
                                    <span class="fw-semibold">{{clientDataRequestSaveModel.contactInformation.fax}}</span>
                                </span>
                            </li>
                    
                        </ul>
                    <button class="btn edit-btn custom-edit-btn ms-auto"
                        (click)="redirectFieldSelectionHandler()">
                        <i class="app-icon icon icon-edit icon-xl"></i>
                    </button>
                </div>
            </div>
            <div class="l-item-section" *ngIf="requestType && requestType.code === clientDataRequestType.Legal">
                <span class="l-section-title fw-semibold">{{ "requests.clientData.preview.legalRepresentatives" | translate }}</span>
                <div HJSuppress class="section-content"  *ngFor="let legalRepresentative of clientDataRequestSaveModel.legalRepresentatives">
                    <div class="d-flex flex-column">
                        <div  class="l-section-subtitle fw-semibold">
                            {{ "requests.clientData.preview.legalRepresentative" | translate}}
                        </div>
                        <ul>
                            <li>
                                <span>
                                    {{'requests.clientData.newRequest.legal.FirstName' | translate}} : 
                                    <span class="fw-semibold">{{legalRepresentative.firstName}}</span>
                                </span>
                            </li>
                            <li>
                                <span>
                                    {{'requests.clientData.newRequest.legal.LastName' | translate}}:
                                    <span class="fw-semibold">{{legalRepresentative.lastName}}</span>
                                </span>
                            </li>
                            <li>
                                <span>
                                    {{'requests.clientData.newRequest.contactInformation.Phone' | translate}}:
                                    <span class="fw-semibold">{{legalRepresentative.phone}}</span>
                                </span>
                            </li>
                    
                        </ul>
                    </div>   
                    <button class="btn edit-btn custom-edit-btn ms-auto"
                        (click)="redirectFieldSelectionHandler()">
                        <i class="app-icon icon icon-edit icon-xl"></i>
                    </button>
                </div>
            </div>
            <div class="l-item-section" *ngIf="requestType && requestType.code === clientDataRequestType.Other">
                <span class="l-section-title fw-semibold">{{ "requests.clientData.preview.details" | translate }}</span>
                <div HJSuppress class="section-content"  >
                    <div class="d-flex flex-column">               
                        <ul>
                            <li>
                                <span>
                                    <span class="fw-semibold">{{clientDataRequestSaveModel.otherField}}</span>
                                </span>
                            </li>
                        </ul>
                    </div>   
                    <button class="btn edit-btn custom-edit-btn ms-auto"
                        (click)="redirectFieldSelectionHandler()">
                        <i class="app-icon icon icon-edit icon-xl"></i>
                    </button>
                </div>
            </div>
            <div class="l-item-section" *ngIf="requestType && requestType.code === clientDataRequestType.BankAccount">
                <span class="l-section-title fw-semibold">{{ "requests.clientData.preview.details" | translate }}</span>
                <div HJSuppress class="section-content"  >
                    <div class="d-flex flex-column">               
                        <ul>
                            <li>
                                <span>
                                    <span class="fw-semibold me-2">{{ 'requests.clientData.newRequest.iban' | translate }}: {{clientDataRequestSaveModel.ibanField}}</span>
                                </span>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <span>
                                    <span class="fw-semibold">{{ 'requests.clientData.newRequest.bank' | translate }}: {{clientDataRequestSaveModel.bankName}}</span>
                                </span>
                            </li>
                        </ul>
                    </div>   
                    <button class="btn edit-btn custom-edit-btn ms-auto"
                        (click)="redirectFieldSelectionHandler()">
                        <i class="app-icon icon icon-edit icon-xl"></i>
                    </button>
                </div>
            </div>

            <div *ngIf="clientDataRequestSaveModel.description" class="d-flex justify-content-center">
                <div class="col-8">
                    <div class=" d-flex justify-content-center">
                        <i class="app-icon icon icon-warning-triangle-fill icon-xl me-2"></i>
                        <span [innerHtml]="clientDataRequestSaveModel.description"></span>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-center mt-5">
            <button
            class="btn primary-btn px-5"
            type="button"
            (click)="sendRequestCofirmationHandler()">
            <span>
                {{ "requests.clientData.newRequest.Send" | translate }}
            </span>
            </button>
        </div>
    </ng-container>

    <ng-container *ngIf="isRequestSaved">
        <client-data-request-sent [navigateToListHandler]="redirectListHandler">
        </client-data-request-sent>
    </ng-container>
</div>
